export default "__VITE_ASSET__cQ7sr$31__"